import React, { FunctionComponent } from 'react';
import { GetCustomizeCarModel_customizeCar } from '../../../../graphql/queries/__generated__/GetCustomizeCarModel';
import ModelSection from './modelSection/ModelSection';
import SectionLoader from '../../../../../common/components/loaders/SectionLoader';
import SpecificationsAndFeaturesContainer from '../specificationsAndFeatures/SpecificationsAndFeaturesContainer';
import useCustomizeCarContext from '../../../../hooks/useCustomizeCarContext';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';
import { useTheme } from '@material-ui/core';

interface IModelContainerProps {
  selectedCarModelData: GetCustomizeCarModel_customizeCar;
  model: string;
}

const ModelContainer: FunctionComponent<IModelContainerProps> = ({ selectedCarModelData, model }) => {
  const { loading } = useCustomizeCarContext();
  const {
    spc: { customise },
  } = useTheme<ISpcTheme>();

  if (loading && !customise?.hideModelContainerLoader) {
    return <SectionLoader />;
  }

  return (
    <ModelSection
      selectedCarModelData={selectedCarModelData}
      model={model}
      detailsSlot={
        <SpecificationsAndFeaturesContainer
          oemCode={selectedCarModelData?.car?.model?.attributes?.oemcode}
          keyFeatures={selectedCarModelData?.car?.keyFeatures}
          specDescription={selectedCarModelData?.car?.attributes?.specDescription}
        />
      }
    />
  );
};

export default ModelContainer;
